/**
 * The app is a BrowserRouter, but links shaped like `/#/login` are still in
 * the wild: welcome emails, enrolment confirmations and the builder's share
 * link all emitted them for months, and an email sits in an inbox long after
 * the code that wrote it is fixed. On a BrowserRouter a hash never reaches the
 * router, so `/#/login` renders whatever lives at `/` — on a published tenant
 * that is the marketing homepage, and the person who clicked "Sign in" in the
 * email is left looking for a login form. (Sept 2026: 18 of 22 invited Revise
 * accounts had never signed in; the invite link was this.)
 *
 * Only `#/…` is a legacy route. Two other hash shapes share the URL and must
 * be left alone: Supabase auth callbacks (`#access_token=…&type=recovery`) and
 * in-page anchors on the landing page (`#try`, `#study`).
 */
export function resolveLegacyHashRoute(hash: string): string | null {
  if (!hash.startsWith('#/')) return null;
  const path = hash.slice(1);
  // Never let a crafted link escape the origin: `#//evil.com` would otherwise
  // become a protocol-relative URL once handed to history.replaceState — and
  // so would `#/\evil.com`, because the URL parser treats a backslash as a
  // slash. Either way the browser throws a SecurityError and the app is left
  // on the unrewritten hash.
  if (path.startsWith('//') || path.startsWith('/\\')) return null;
  return path;
}
